export default __webpack_public_path__ + "static/polacode-93fef1748a0b198c23ebaae1b515b962.png";